module.exports = __webpack_public_path__ + "img/logo.749fa64b.png";